module.exports = __webpack_public_path__ + "img/icon-no-voucher.f9f7e959.svg";